import React from 'react';
import { SimpleGrid, Box, Heading } from '@chakra-ui/react';

const Features = () => {
  const features = [
    {
      heading: 'Premium client gallery',
      description: 'Well designed client albums for any device experience',
    },
    {
      heading: 'Easy quick sharing',
      description:
        'Clients can easily share to friends and family within a tap',
    },
    {
      heading: 'Upload in orginal size',
      description: 'All photos uploaded will be on cloud with orginal size',
    },
    {
      heading: 'Password protected',
      description:
        'Albums or photos can be easily shared privately with a password',
    },
  ];

  return (
    <SimpleGrid
      columns={[1, 2, 2]}
      spacingX='80px'
      spacingY='80px'
      color='#fff'
      textAlign='left'
      px={['32px', '32px', '32px', '0px']}
    >
      {features.map((item, index) => (
        <Box key={index} w={['100%', '100%', '100%', '95%']}>
          <Heading as='h2' fontSize='28px' fontWeight='bold' fontFamily='bold'>
            {item.heading}
          </Heading>
          <Box fontSize='18px' mt='16px'>
            {item.description}
          </Box>
        </Box>
      ))}
    </SimpleGrid>
  );
};
export default Features;
